import React, { Component } from "react";
import { connect } from "react-redux";

import TypingPracticeTest from "./TypingPracticeTest";
import DataEntryPracticeTest from "./DataEntryPracticeTest";

export class MainPracticeTest extends Component {
  render() {
    let PracticeTest = null;

    if (["Typing Test V1", "Typing Test V2"].includes(this.props.exam_name)) {
      PracticeTest = <TypingPracticeTest />;
    }

    if (["Data Entry V1", "Data Entry V2"].includes(this.props.exam_name)) {
      PracticeTest = <DataEntryPracticeTest />;
    }

    return <>{PracticeTest}</>;
  }
}

const mapStateToProps = (state) => ({
  ...state,
  exam_name: state.assessment.exams[state.assessment.exam_index].name,
});

export default connect(mapStateToProps)(MainPracticeTest);
